import React from 'react';
import activeIcon from '@/assets/step_active.svg';
import activeBlueIcon from '@/assets/step_active_blue.svg';
import inactiveIcon from '@/assets/step_inactive.svg';

const HIDDEN_COLOR = 'bg-transparent';

const Stepper = ({ 
  steps, 
  useBlue = false,
  activeColor = 'bg-orange-500', 
  inactiveColor = 'bg-gray-200',
  inactiveTextColor = 'text-gray-400'
}) => {
  return (
    <div className="w-full my-1.5">
      <div className="flex items-start w-full">
        {steps.map((step, index) => {
          const isFirst = index === 0;
          const isLast = index === steps.length - 1;
          return (
            <div 
              key={index} 
              className="flex-1 flex flex-col items-center relative"
            >
              {/* Icon and connectors row, fixed height */}
              <div className="flex items-center w-full" style={{ minHeight: '24px' }}>
                {/* Left connector for non-first steps */}
                <div 
                  className={`h-0.5 flex-1 ${isFirst ? HIDDEN_COLOR : steps[index].completed ? activeColor : inactiveColor}`}
                />
                {/* Step circle */}
                {step.completed ? (
                  <img src={useBlue ? activeBlueIcon : activeIcon} alt={step.label} className="w-5 h-5 shrink-0" />
                ) : (
                  <img src={inactiveIcon} alt={step.label} className="w-5 h-5 shrink-0" />
                )}
                {/* Right connector for non-last steps */}
                <div 
                  className={`h-0.5 flex-1 ${isLast ? HIDDEN_COLOR : steps[index+1]?.completed ? activeColor : inactiveColor}`}
                />
              </div>
              {/* Step label, allow wrapping, does not affect icon row */}
              <div className="mt-1 px-1 w-full flex justify-center">
                <span className={`text-xs break-words text-center ${
                  step.active || step.completed
                    ? 'text-black font-medium' 
                    : inactiveTextColor
                }`}>
                  {step.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper; 